
const options = {
    rootMargin: '0px',
    threshold: 0.25
}

window.addEventListener('load', (event) => {

    function runImageAnimation2seconds(image) {
        var paths = image.querySelectorAll('path');
        paths.forEach(path => {
            var length = path.getTotalLength();
            // Clear any previous transition
            path.style.transition = path.style.WebkitTransition = 'none';
            // Set up the starting positions
            path.style.strokeDasharray = length + ' ' + length;
            path.style.strokeDashoffset = length;
            // Trigger a layout so styles are calculated & the browser
            // picks up the starting position before animating
            path.getBoundingClientRect();
            // Define our transition
            //path.style.transition = path.style.WebkitTransition = 'opacity 0.25s ease-in-out';
            path.style.transition = path.style.WebkitTransition = 'stroke-dashoffset 2s ease-in-out';
            // Go!
            path.style.strokeDashoffset = '0';
        });
    }

    function runImageAnimation4seconds(image) {
        var paths = image.querySelectorAll('path');
        paths.forEach(path => {
            var length = path.getTotalLength();
            // Clear any previous transition
            path.style.transition = path.style.WebkitTransition = 'none';
            // Set up the starting positions
            path.style.strokeDasharray = length + ' ' + length;
            path.style.strokeDashoffset = length;
            // Trigger a layout so styles are calculated & the browser
            // picks up the starting position before animating
            path.getBoundingClientRect();
            // Define our transition
            //path.style.transition = path.style.WebkitTransition = 'opacity 0.25s ease-in-out';
            path.style.transition = path.style.WebkitTransition = 'stroke-dashoffset 4s ease-in-out';
            // Go!
            path.style.strokeDashoffset = '0';
        });
    }

    const images = document.querySelectorAll('.anim');


    function runIntersectionObserver(images) {

        let observer = new IntersectionObserver((entries) => {

            entries.forEach(image => {
                var svg2s = image.target.querySelector('.squiggle2s');

                if (svg2s) {
                    if (Object.entries(svg2s) != null && image.intersectionRatio > 0.15) {
                        svg2s.style.opacity = "1";
                        runImageAnimation2seconds(image.target);
                        observer.unobserve(image.target);
                    }
                }

                var svg4s = image.target.querySelector('.squiggle4s');
                if (svg4s) {

                    if (Object.entries(svg4s) != null && image.intersectionRatio > 0.15) {
                        svg4s.style.opacity = "1";
                        runImageAnimation4seconds(image.target);
                        observer.unobserve(image.target);
                    }

                }
            })
        }, options)

        images.forEach(image => {
            observer.observe(image);
        })
    }

    runIntersectionObserver(images);

});